import { render } from "./assignLeads.vue?vue&type=template&id=5e2d3b6c&scoped=true"
import script from "./assignLeads.vue?vue&type=script&lang=js"
export * from "./assignLeads.vue?vue&type=script&lang=js"

import "./assignLeads.vue?vue&type=style&index=0&id=5e2d3b6c&scoped=true&lang=css"
import "./assignLeads.vue?vue&type=style&index=1&id=5e2d3b6c&lang=css"
script.render = render
script.__scopeId = "data-v-5e2d3b6c"

export default script